import { render, staticRenderFns } from "./PersonalDetail.vue?vue&type=template&id=0d8295fb&shadow"
import script from "./PersonalDetail.vue?vue&type=script&lang=js&shadow"
export * from "./PersonalDetail.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./PersonalDetail.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./PersonalDetail.vue?vue&type=style&index=1&lang=css&shadow")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports